import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';

export const memoExportScheme = z.object({
  eventId: z.number().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
});

export type MemoExportSchemeType = z.infer<typeof memoExportScheme>;

export type MemoExportLockedFields = {
  eventId?: boolean;
  startDate?: boolean;
  endDate?: boolean;
};

export const getDefaultMemoExportFields = (
  arg?: Partial<MemoExportSchemeType>,
): MemoExportSchemeType => ({
  eventId: undefined,
  startDate: undefined,
  endDate: undefined,
  ...arg,
});

export const useMemoExportForm = ({ defaultValues }: { defaultValues: MemoExportSchemeType }) => {
  return useForm<MemoExportSchemeType>({
    resolver: zodResolver(memoExportScheme),
    mode: 'onChange',
    defaultValues,
  });
};

export const useMemoExportFormContext = () => {
  return useFormContext<MemoExportSchemeType>();
};
